// extracted by mini-css-extract-plugin
export var active = "language-selector-module--active--fd87f";
export var arrowIcon = "language-selector-module--arrowIcon--9f909";
export var countryFlag = "language-selector-module--countryFlag--3b922";
export var countryLabel = "language-selector-module--countryLabel--23c0b";
export var dropdownContent = "language-selector-module--dropdown-content--374b8";
export var languageSelectorMenu = "language-selector-module--languageSelectorMenu--576e5";
export var menuButton = "language-selector-module--menuButton--4dc45";
export var openUpward = "language-selector-module--openUpward--f1092";
export var subMenuButton = "language-selector-module--subMenuButton--c7384";